import React, { Component } from 'react';
import { connect } from 'react-redux';
import config from 'config/api';
import Spinner from 'components/UI/Spinner';
import HomeNoEvents from './HomeNoEvents';
import HomeVisitor from './HomeVisitor';
import HomeSubscribe from './HomeSubscribe';
import Header from '../Header/Header';
import ScrollToTopOnMount from 'components/UI/ScrollToTopOnMount';
import { withRouter } from 'react-router-dom';
import { withStyles, withTheme } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import Banner from 'components/Banner/Banner';
import getRemainingTime from 'helpers/getRemainingTime';
import RemainingTime from 'components/UI/RemainingTime';
import Immutable from 'immutable';
import Typography from '@material-ui/core/Typography';
import Paragrapher from 'components/UI/Paragrapher/Paragrapher';
import Fade from '@material-ui/core/Fade';
import { fetchData, getDataHome, getLoadingError } from '../../ducks/asyncFetcher';
import { isLoggedIn, getCurrentUserRole, getCurrentUser, isStateKnown } from 'ducks/authentication';
import clsx from 'clsx';
import Footer from '../Footer';
import gotoLiveRoom from 'helpers/gotoLiveRoom';
import i18n from 'helpers/i18n';

const styles = (theme) => {
  return {
    root: {
      minWidth: '100%',
      minHeight: '920px',
      // display: "flex",
      // flexDirection: "column",
      // "& > *": {
      //   flex: 1,
      // },
      color: '#fff',
    },
    withBg: {
      backgroundImage: `url(${require('assets/images/' + process.env.REACT_APP_SITE + '/background.jpg')})`,
      backgroundPosition: '0 0',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      [theme.breakpoints.down('sm')]: {
        backgroundPosition: '0 0',
      },
    },
    header: {
      height: 150,
      [theme.breakpoints.down('sm')]: {
        height: 'auto',
        borderBottom: 'none',
      },
    },
    content: {
      minHeight: 'calc(100% - 170px - 125px)',
      [theme.breakpoints.down('md')]: {
        height: 'auto',
        minHeight: 'auto',
      },
    },
    regularHeight: {
      height: 'auto',
    },
    footer: {
      color: '#fff',
      height: 125,
      [theme.breakpoints.down('sm')]: {
        height: 'auto',
      },
    },
  };
};

const AF_KEY = 'home';

class HomeClass extends Component {
  constructor(props) {
    super(props);
    this._runRemainingTimer = this._runRemainingTimer.bind(this);
    this.state = {
      showLiveButton: false,
      timeRemaining: {},
    };
  }

  componentDidMount() {
    const { classes } = this.props;
    this.props.onMount();
    // document.body.classList.add(classes.withBg);
    this._setPageBackground();
    this._onWindowResize();
    window.addEventListener('resize', this._onWindowResize);
  }

  componentDidUpdate(oldProps) {
    if (oldProps.$$data !== this.props.$$data) {
      this._onWindowResize();
      this._startTimer();
    }
    if (oldProps.subscribe === true && this.props.subscribe === false) this._setPageBackground();
  }

  componentWillUnmount() {
    // console.log('unmount')
    window.removeEventListener('resize', this._onWindowResize);
    this._stopTimer();
  }

  _setPageBackground = () => {
    const { classes } = this.props;
    document.querySelector('#root').classList.add(classes.withBg);
    delete document.querySelector('#root').style['background-image'];
  };
  _onWindowResize = () => {
    const { classes } = this.props;
    const el = document.querySelector('#root');
    // console.log('resize', el.offsetHeight, window.innerHeight);
    el.style.height = 'auto';
    if (el.offsetHeight <= window.innerHeight) {
      // console.log('fixing');
      el.style.height = window.innerHeight + 'px';
    } else {
      // console.log('releasing');
      el.style.height = 'auto';
    }
  };

  _stopTimer() {
    if (this._remainingTimer) {
      clearInterval(this._remainingTimer);
    }
  }
  _startTimer() {
    if (this._remainingTimer) return;
    const $$liveEvent = this._getMyLiveEvent();
    if ($$liveEvent === undefined) return;
    this._remainingTimer = setInterval(this._runRemainingTimer, 1000);
    this._runRemainingTimer();
  }

  _runRemainingTimer() {
    const $$liveEvent = this._getMyLiveEvent();
    if ($$liveEvent === undefined) {
      return this._stopTimer();
    }
    const timeRemaining =
      $$liveEvent !== undefined && $$liveEvent.get('eventState') !== 'live'
        ? getRemainingTime($$liveEvent.get('eventDate'))
        : { days: 0, hours: 0, minutes: 0 };
    if (timeRemaining.days <= 0 && timeRemaining.hours <= 0 && timeRemaining.minutes <= 15) {
      this.setState({ showLiveButton: true }, () => {
        this._stopTimer();
      });
    } else {
      this.setState({ timeRemaining });
    }
  }

  _getMySubscriptions() {
    const { userRole, $$data } = this.props;
    const $$subscriptions =
      userRole !== undefined && $$data !== undefined && $$data.get('myfutureevents') !== undefined
        ? $$data.get('myfutureevents').map((e) => e.get('id'))
        : Immutable.Map();
    return $$subscriptions;
  }

  _getMyLiveEvent() {
    const { $$data } = this.props;
    const $$subscriptions = this._getMySubscriptions();
    return $$subscriptions !== undefined && $$subscriptions.size > 0 && $$subscriptions.get(0) !== undefined
      ? $$data.get('myfutureevents').get(0)
      : undefined;
  }

  _goto = (url) => {
    const { history } = this.props;
    history.push(url);
  };

  _gotoLiveRoom = (e) => {
    e.preventDefault();
    const $liveEvent = this._getMyLiveEvent();
    gotoLiveRoom($liveEvent, (res) => {
      if (res === true) this._goto('/live/' + $liveEvent.get('id'));
    });
  };

  _scrollToEvent() {
    const $$liveEvent = this._getMyLiveEvent();
    const elem = document.getElementById('event-card-' + $$liveEvent.get('themeName'));
    let rect = elem.getBoundingClientRect();

    window.scroll({
      top: rect.y,
      left: 0,
      behavior: 'smooth',
    });
  }

  _gotoThemePage = (themeId) => {
    this.props.history.push('/subscribe/' + themeId);
  };
  render() {
    const { $$data, userRole, onPanelToggle, $$user, classes, subscribe, isLoggedIn, themeId } = this.props;
    const { showLiveButton, timeRemaining } = this.state;
    const $$liveEvent = this._getMyLiveEvent();

    const $$subscriptions = this._getMySubscriptions();
    let finalThemeId = themeId;

    const $$availableEvents =
      $$data !== undefined && $$data.get('availableEvents') !== undefined
        ? $$data.get('availableEvents')
        : undefined;
    const $$pastEvents =
      $$data !== undefined && $$data.get('pastEvent') !== undefined ? $$data.get('pastEvent') : undefined;

    return (
      <Fade in timeout={1000} style={{ height: '100%' }}>
        <div>
          <Container disableGutters fixed style={{ height: '100%' }}>
            <ScrollToTopOnMount />
            <Grid container spacing={0} style={{ height: '100%' }}>
              <Grid
                item
                xs={12}
                className={clsx(classes.header, {
                  [classes.regularHeight]: $$data !== undefined && isLoggedIn,
                })}
              >
                <Header
                  onPanelToggle={onPanelToggle}
                  current="home"
                  headerImage={isLoggedIn ? undefined : undefined}
                  headerContent={
                    isLoggedIn && $$liveEvent !== undefined && subscribe !== true ? (
                      <Box mt={4}>
                        <Typography
                          variant={'h4'}
                          align="center"
                          style={{ fontSize: '1rem' }}
                          gutterBottom={true}
                        >
                          {i18n.get('headerTitle')}
                        </Typography>
                        <Typography
                          variant={'h4'}
                          align="center"
                          style={{ fontSize: '1rem' }}
                          gutterBottom={true}
                          component={'div'}
                        >
                          <Paragrapher text={$$liveEvent.get('eventTitle')} prettyfy={true} />
                        </Typography>

                        <Choose>
                          <When condition={showLiveButton}>
                            <Typography variant="body1" gutterBottom={true}>
                              {i18n.get('headerSubtitle1')}
                            </Typography>
                            <Box mt={2}>
                              <Button
                                variant="outlined"
                                color="secondary"
                                onClick={this._gotoLiveRoom}
                                className={classes.buttonLarge}
                              >
                                {i18n.get('headerBtn1')}
                              </Button>
                            </Box>
                          </When>
                          <Otherwise>
                            <Typography
                              variant={'h4'}
                              align="center"
                              style={{ fontSize: '1rem' }}
                              gutterBottom={true}
                            >
                              {i18n.get('headerSubtitle2')}
                            </Typography>
                            <RemainingTime
                              days={timeRemaining.days}
                              hours={timeRemaining.hours}
                              minutes={timeRemaining.minutes}
                              variant="subtitle2"
                            />
                            <Box mt={2}>
                              <Button
                                variant="outlined"
                                color="secondary"
                                onClick={(e) => {
                                  e.preventDefault();
                                  this._gotoThemePage($$liveEvent.get('themeId'));
                                }}
                              >
                                {i18n.get('headerBtn2')}
                              </Button>
                            </Box>
                          </Otherwise>
                        </Choose>
                      </Box>
                    ) : undefined
                  }
                />
              </Grid>
              <Grid
                item
                xs={12}
                container
                className={clsx(classes.content, {
                  [classes.regularHeight]: $$data !== undefined && isLoggedIn,
                })}
              >
                <Choose>
                  <When condition={$$data !== undefined && ($$data.get('availableEvents') === undefined || $$data.get('availableEvents').size < 1)}>
                    <HomeNoEvents
                      $$data={$$data}
                      $$user={$$user}
                      userRole={userRole}
                      isLoggedIn={isLoggedIn}
                      onSubscriptionComplete={this.props.onMount}
                    />
                  </When>
                  <When condition={$$data !== undefined && ($$data.get('availableEvents') !== undefined && $$data.get('availableEvents').size > 0) && subscribe !== true}>
                    <HomeVisitor
                      $$data={$$data}
                      $$user={$$user}
                      userRole={userRole}
                      isLoggedIn={isLoggedIn}
                      onSubscriptionComplete={this.props.onMount}
                    />
                    <If condition={$$data !== undefined && isLoggedIn}>
                      <Banner />
                    </If>
                  </When>
                  <When condition={$$data !== undefined && subscribe === true}>
                    <HomeSubscribe
                      $$availableEvents={$$availableEvents}
                      $$data={$$data}
                      $$user={$$user}
                      userRole={userRole}
                      isLoggedIn={isLoggedIn}
                      onSubscriptionComplete={this.props.onMount}
                      $$subscriptions={$$subscriptions}
                      $$pastEvents={$$pastEvents}
                      themeId={finalThemeId}
                      onResize={this._onWindowResize}
                    />
                  </When>

                  <Otherwise>
                    <Spinner>{i18n.get('loading')}</Spinner>
                  </Otherwise>
                </Choose>
              </Grid>
              <Footer className={classes.footer} colouredBackground={!isLoggedIn} />
            </Grid>
          </Container>
        </div>
      </Fade>
    );
  }
}

function mapStateToProps(state) {
  const props = {
    $$data: getDataHome(state),
    error: getLoadingError(state),
    isLoggedIn: isLoggedIn(state),
    userRole: getCurrentUserRole(state),
    authStateKnown: isStateKnown(state),
    $$user: getCurrentUser(state),
  };
  return props;
}
function mapDispatchToProps(dispatch) {
  return {
    onMount: () => {
      dispatch(fetchData({ key: AF_KEY, fetchUrl: config.home }));
    },
  };
}

const HomeWrapper = withRouter(connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(HomeClass)));

export default HomeWrapper;



// WEBPACK FOOTER //
// ./src/components/Home/Home.jsx